<template>
  <div class="upload-main">
    <input type="file" style="display: none" ref="multipleFile" accept="image/*" @change="multipleFileChange($event)"
           multiple="multiple"/>
    <input type="file" style="display: none" ref="singleFile" accept="image/*" @change="singleFileChange($event)"/>
    <div class="item-wrapper">
      <div class="item img" :class="!isAvatarMode ? 'list-item' : ''" v-for="(item, index) in uploadList"
           :key="item.path"
           :style="customStyle"
           @mouseenter="item.over = true"
           @mouseleave="item.over = false">
        <el-image :src="item.url" fit="cover" class="img" @load="item.loadSuccess = true"></el-image>
        <div class="mask load-progress" v-show="item.progress > 0 && item.progress < 100">
          <el-progress style="width: 100%;margin: 0 10px" :text-inside="true" :stroke-width="20"
                       :percentage="item.progress" :color="progressColor"></el-progress>
        </div>
        <transition name="el-fade-in-linear">
          <div class="mask option-mask" v-show="(isChange && item.over) || item.fail">
            <i class="close el-icon-close" @click="remove(index)" title="移除" v-if="!isAvatarMode || item.fail"></i>
            <span v-if="item.fail" class="text failed-msg">上传失败</span>
            <span v-else>
                <span @click="popoverRefChangeShow($event, index)" v-if="isChange" class="text option">
                  {{ changeText }}
                </span>
                  <span @click="cut(index)" v-if="isChange && !isAvatarMode && item.loadSuccess" class="text option">
                  裁剪
                </span>
            </span>
          </div>
        </transition>
      </div>
      <div @click="popoverRefChangeShow($event)" class="item add" :class="!isAvatarMode ? 'list-item' : ''"
           :style="customStyle"
           v-show="uploadList.length < limit">
        <span><i class="el-icon-plus avatar-uploader-icon"></i></span>
      </div>
    </div>
    <el-popover ref="popover" placement="right-start" trigger="click" :width="400" :manual="true"
                v-model="sourceType.showFlag">
      <el-form ref="form" :rules="rules" :model="sourceType" size="mini">
        <el-form-item>
          <el-radio-group v-model="sourceType.type" :disabled="sourceType.loadingFlag">
            <el-radio label="local">本地图片</el-radio>
            <el-radio label="web">网络图片</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="url" v-if="sourceType.type === 'web'">
          <el-input type="textarea" resize="none" :disabled="sourceType.loadingFlag"
                    placeholder="图片链接" :autosize="{minRows: 2, maxRows: 8}" v-model="sourceType.url"></el-input>
        </el-form-item>
        <el-button type="primary" size="mini" @click="chooseSourceType" :loading="sourceType.loadingFlag">{{
          sourceType.loadingFlag ? '下载中' : '确定'}}
        </el-button>
        <el-link style="vertical-align: bottom;font-size: 12px;" type="danger" v-show="sourceType.type === 'web' && sourceType.failedDescribe"
                 :href="sourceType.url" target="_blank" referrer="no-referrer" referrerPolicy="no-referrer">
          <i class="el-icon-error"></i>
          {{ sourceType.failedDescribe }}
        </el-link>
      </el-form>
    </el-popover>
  </div>
</template>

<script>
    import {uuid} from "../../js/utils/uuid";
    import setting from "../../config/setting";
    import cropperBus from "../../js/bus/cropperBus";
    import { _legalWebUrl } from "../../js/utils/el-form-validate-rules";
    import axios from 'axios';

    export default {
        name: "UploadImg",
        props: {
            //oss上传参数
            uploadOption: {
                type: Object,
                default: () => {
                }
            },
            //添加图片图标样式（圆角或方角）
            customStyle: {
                type: Object,
                required: false,
            },
            //上传数量限制
            countLimit: {
                type: Number,
                default: 9,
            },
            //是否是头像模式
            isAvatarMode: {
                type: Boolean,
                default: false,
            },
            //初始默认图片
            defaultImg: {
                type: Array,
                default: () => [],
            },
            //是否有更换图片功能
            isChange: {
                type: Boolean,
                default: true,
            },
            //更换功能文字描述
            changeText: {
                type: String,
                default: "更换",
            },
            /**
             * 是否确定文件后自动上传
             */
            autoUpload: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                //唯一id用于对应和Cropper组件通讯
                id: uuid(),
                //当前裁剪是否是重新裁剪图片 （uploadList的索引，-1则不是重新裁剪模式）
                replaceIndex: -1,
                /**
                 * 模型字段
                 * {
                    url: URL.createObjectURL(blob),  //img图片地址
                    path: setting.ossUploadPre + uuid() + "." + blob.type.split("/")[1],  //上传到oss的全路径名
                    progress: 0,  //上传进度
                    over: false,  //鼠标over事件
                    fail: false,  //是否上传失败
                    loadSuccess: false, //img标签加载是否成功
                    blob: blob, //该blob对象
                    isUpload: false //是否已经上传
                };
                 */
                uploadList: [],
                progressColor: [
                    {color: '#909399', percentage: 30},
                    {color: '#e6a23c', percentage: 70},
                    {color: '#67c23a', percentage: 100}
                ],
                sourceType: {
                    type: 'local',
                    url: '',
                    loadingFlag: false,
                    failedDescribe: '',
                    showFlag: false
                },
                rules: {
                    url: [
                        {required: true, message: '请输入图片链接', trigger: 'blur'},
                        {validator: _legalWebUrl, trigger: 'blur'}
                    ]
                },
                errorMap: {
                    typeError: '该链接不是一个合法图片格式链接',
                    sizeLimit: '该图链接片大小已超过1MB',
                    responseError: '该链接响应异常（点击尝试访问）',
                    redirected: '该链接图片已被转移，请手动获取',
                }
            }
        },
        methods: {
            //校验上传数量限制
            checkUploadLimit(fileArr) {
                if ((this.uploadList.length + (this.isChangeMode ? 0 : fileArr.length)) > this.limit) {
                    return "最多上传" + this.limit + "张图片";
                }
            },
            checkImgMineType(type) {
                return /^image\/[.a-z]+/g.test(type);
            },
            //校验文件类型和大小
            checkUploadFile(fileArr) {
                for (let i = 0; i < fileArr.length; i++) {
                    if (!this.checkImgMineType(fileArr[i].type)) {
                        return "请上传图片格式文件";
                    }
                    if (fileArr[i].size > setting.imgUploadSize) {
                        return "图片不能超过512KB";
                    }
                }
            },
            singleFileChange(e) {
                let files = e.target.files;
                let check = this.checkUploadLimit(files) || this.checkUploadFile(files);
                if (check) {
                    e.target.value = "";
                    return this.$im.showMessage(check, {icon: 5})
                }
                if (this.isAvatarMode) {
                    cropperBus.show(this.id, files[0]);
                } else {
                    if (this.isChangeMode) {
                        this.reUpload(files[0]);
                    } else {
                        this.upload(files[0]);
                    }
                }
                e.target.value = "";
            },
            multipleFileChange(e) {
                let files = e.target.files;
                let check = this.checkUploadLimit(files) || this.checkUploadFile(files);
                if (check) {
                    e.target.value = "";
                    return this.$im.showMessage(check, {icon: 5})
                }
                for (let i = 0; i < files.length; i++) {
                    this.upload(files[i]);
                }
                e.target.value = "";
            },
            //添加图片
            add() {
                if (this.isAvatarMode || this.isChangeMode) {
                    this.$refs.singleFile.click();
                } else {
                    this.$refs.multipleFile.click();
                }
            },
            //上传oos
            executeOSSUpload(uploadPath, blob, successEvent, progressEvent, errorEvent, completeEvent) {
                this.$im.ossUpload(uploadPath,
                    blob,
                    this.uploadOption,
                    successEvent,
                    progressEvent,
                    errorEvent,
                    completeEvent);
            },
            //上传
            upload(file) {
                let blob = new Blob([file], {type: file.type});
                let upload = {
                    url: URL.createObjectURL(blob),
                    path: setting.ossUploadPre + uuid() + "." + blob.type.split("/")[1],
                    progress: 0,
                    over: false,
                    fail: false,
                    loadSuccess: false,
                    blob: blob,
                    isUpload: this.autoUpload
                };
                this.uploadList.push(upload);
                if (this.autoUpload) {
                    this.executeOSSUpload(upload.path, upload.blob, () => {
                        this.change();
                    }, (progress) => {
                        upload.progress = progress;
                    }, () => {
                        upload.progress = 0;
                        upload.fail = true;
                        upload.isUpload = false;
                    });
                }
            },
            //重新上传
            reUpload(file) {
                let blob = new Blob([file], {type: file.type});
                let upload = this.uploadList[this.replaceIndex];
                this.replaceIndex = -1;
                URL.revokeObjectURL(upload.url);
                upload.loadSuccess = false;
                upload.url = URL.createObjectURL(blob);
                upload.progress = 0;
                upload.path = setting.ossUploadPre + uuid() + "." + blob.type.split("/")[1];
                upload.blob = blob;
                upload.fail = false;
                upload.isUpload = this.autoUpload;
                if (this.autoUpload) {
                    this.executeOSSUpload(upload.path, upload.blob, () => {
                        this.change();
                    }, (progress) => {
                        upload.progress = progress;
                    }, () => {
                        upload.progress = 0;
                        upload.fail = true;
                        upload.isUpload = false;
                    });
                }
            },
            //移除添加的图片
            remove(index) {
                this.uploadList.splice(index, 1);
                this.change();
            },
            cut(index) {
                this.replaceIndex = index;
                cropperBus.show(this.id, this.uploadList[index].url, false);
            },
            clean() {
                for (let i = 0; i < this.uploadList.length; i++) {
                    URL.revokeObjectURL(this.uploadList[i].url);
                }
                this.uploadList = [];
                this.change();
            },
            change() {
                let map = this.uploadList.filter(item => item.progress >= 100).map(item => item.path);
                this.$emit("change", map);
                return map;
            },
            chooseSourceType() {
                this.$refs.form.validate((valid) => {
                    if (!valid)
                        return;
                    if (this.sourceType.type === 'local')
                        return this.add();
                    this.sourceType.loadingFlag = true;
                    axios.get(this.sourceType.url, {
                        responseType: 'blob',
                    }).then(response => response.data).catch(({message, response}) => {
                        if (response && response.status === 403 && window.fetch) { //如果图片被防盗链限制，且js支持fetch，继续then处理
                            return "use fetch";
                        }
                        //被同源限制、非20x、未知错误等
                        throw new Error(message);
                    }).then((data) => {
                        if (data === "use fetch")  //是否使用fetch方法获取图片
                            return window.fetch(this.sourceType.url, {
                                // referrer: "", // 将referer置空
                                referrerPolicy: 'no-referrer',
                            });
                        //blob直接返回
                        return data;
                    }).then(data => {
                        if (data instanceof Response) { //如果是fetch的返回
                            if (data.redirected) //如果是30x重定向
                                throw new Error("redirected");
                            if (!data.ok) //如果状态不为20x
                                throw new Error("responseError");
                            //返回blob的Promise
                            return data.blob();
                        }
                        //blob直接返回
                        return data;
                    }).then(blob => {
                        if (!this.checkImgMineType(blob.type)) //检查blob类型
                            throw new Error("typeError");
                        if (blob.size > setting.sendImgSize)
                            throw new Error("sizeLimit");
                        this.handleWebBlob(blob);
                    }).catch(({message, response}) => {
                        let myError = this.errorMap[message];
                        if (myError) {
                            this.sourceType.failedDescribe = myError;
                        } else if (response) {
                            this.sourceType.failedDescribe = "该链接响应异常（点击尝试访问）";
                        } else {
                            this.sourceType.failedDescribe = "该链接禁止其他网站获取，请手动保存后本地上传";
                        }
                    }).finally(() => {
                        this.sourceType.loadingFlag = false;
                    })
                });
            },
            handleWebBlob(blob) {
                this.$refs.form.resetFields();
                this.sourceType.failedDescribe = '';
                this.sourceType.showFlag = false;
                if (this.isAvatarMode) {
                    cropperBus.show(this.id, blob);
                } else {
                    if (this.isChangeMode) {
                        this.reUpload(blob);
                    } else {
                        this.upload(blob);
                    }
                }
            },
            popoverRefChangeShow(e, replaceIndex = -1) {
                if (replaceIndex >= 0)
                    this.replaceIndex = replaceIndex;
                else
                    this.replaceIndex = -1;
                let pop = this.$refs.popover;
                //改变popover内部的指向
                pop.referenceElm = pop.$refs.reference = e.currentTarget;
                //显示
                pop.doToggle();
            },
            /**
             * 手动触发上传
             * 返回所有当前已上传列表 Promise
             */
            manualUpload() {
                return Promise.all(this.uploadList.filter(({isUpload}) => !isUpload).map(item => {
                    return new Promise((resolve, reject) => {
                        item.fail = false;
                        this.executeOSSUpload(item.path, item.blob, () => {
                            resolve(item.path);
                        }, (progress) => {
                            item.progress = progress;
                        }, () => {
                            item.progress = 0;
                            item.fail = true;
                            item.isUpload = false;
                            reject();
                        })
                    });
                })).then(imgPath => {
                    this.change();
                    return imgPath;
                });
            }
        },
        created() {
            for (let i = 0; i < this.defaultImg.length; i++) {
                if (i >= this.limit) {
                    break
                }
                let item = {
                    progress: 100,
                    over: false,
                    fail: false,
                    loadSuccess: false,
                };
                if (this.defaultImg[i].indexOf(setting.ossUploadPre) === 0) {
                    item.url = setting.oosPublicDomain + this.defaultImg[i];
                    item.path = this.defaultImg[i];
                } else {
                    item.url = item.path = this.defaultImg[i];
                }
                this.uploadList.push(item);
            }
            //监听Cropper裁剪后的回调
            cropperBus.onCallback(this.id, (blob) => {
                //重新裁剪模式
                if (this.isChangeMode) {
                    this.reUpload(blob);
                } else {
                    this.upload(blob);
                }
            })
        },
        computed: {
            //当前是否是替换模式
            isChangeMode() {
                return this.replaceIndex >= 0;
            },
            limit() {
                return this.isAvatarMode ? 1 : this.countLimit;
            }
        },
        destroyed() {
            this.clean();
        }
    }
</script>

<style scoped>

  .item-wrapper {
    font-size: 0;
    margin-bottom: -8px;
    user-select: none;
  }

  .item {
    min-width: 60px;
    min-height: 60px;
    border: 1px solid #eee;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    display: inline-block;
    font-size: 14px;
  }

  .list-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .add {
    cursor: pointer;
  }

  .add > span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }


  .item .img {
    width: 100%;
    height: 100%;
  }

  .item .load-progress {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #00000091;
  }

  .item .option-mask {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: whitesmoke;
  }

  .item .option-mask .close {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
    font-weight: bold;
  }

  .item .option-mask .option {
    cursor: pointer;
  }

  .item .option-mask .text {
    font-weight: bold;
  }

  .failed-msg {
    color: #ccc;
  }

  .item .option-mask .option:hover {
    text-decoration: underline;
  }


</style>



// WEBPACK FOOTER //
// src/view/component/UploadImg.vue